export function checkMaintenanceExclude(toPath, exclude = []) {
  if (!exclude || exclude.length === 0) {
    return false;
  }
  return exclude.some((excludedPath) => {
    const normalizedToPath = toPath.replace(/\/$/, "");
    const normalizedExcludedPath = excludedPath.replace(/\/$/, "");
    return normalizedToPath.startsWith(normalizedExcludedPath);
  });
}
